<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditLeaveType"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="edit"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full h-full overflow-y-scroll"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Time Off Type</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Time off Name</label>
              <input
                v-model="leaveTypeToEdit.Name"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full capitalize"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Number of days</label>
              <input
                v-model="leaveTypeToEdit.NumberOfDays"
                min="0"
                required
                type="number"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Earned Per Month</label>
              <input
                v-model="leaveTypeToEdit.EarnedPerMonth"
                min="0"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="">
              <label class="block text-sm mb-2" for="consecutive-switch">
                Consecutive
              </label>
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="consecutive-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  v-model="leaveTypeToEdit.Consecutive"
                  :disabled="leaveTypeToEdit.IncludeSaturday"
                />
                <label for="consecutive-switch" class="ml-2 block text-sm">
                  Leave is consecutive
                </label>
              </div>
            </div>

            <div class="">
              <label class="block text-sm mb-2" for="apply-before-today-switch">
                Apply Before Today
              </label>
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="apply-before-today-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  v-model="leaveTypeToEdit.ApplyBeforeToday"
                />
                <label
                  for="apply-before-today-switch"
                  class="ml-2 block text-sm"
                >
                  Start date can be in the past
                </label>
              </div>
            </div>

            <div class="">
              <label class="block text-sm mb-2" for="include-saturday-switch">
                Saturdays
              </label>
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="include-saturday-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  :disabled="leaveTypeToEdit.Consecutive"
                  v-model="leaveTypeToEdit.IncludeSaturday"
                />
                <label for="include-saturday-switch" class="ml-2 block text-sm">
                  Leave includes Saturdays
                </label>
                <div v-if="leaveTypeToEdit.IncludeSaturday" class="ml-4">
                  <label class="inline-flex items-center ml-2">
                    <input
                      type="radio"
                      class="form-radio cursor-pointer"
                      name="radio"
                      :checked="leaveTypeToEdit.SaturdayHalf"
                      @click="
                        () => {
                          leaveTypeToEdit.SaturdayHalf = true;
                          leaveTypeToEdit.SaturdayFull = false;
                        }
                      "
                    />
                    <span class="ml-2">Half Day</span>
                  </label>
                  <label class="inline-flex items-center ml-2">
                    <input
                      type="radio"
                      class="form-radio cursor-pointer"
                      name="radio"
                      :checked="leaveTypeToEdit.SaturdayFull"
                      @click="
                        () => {
                          leaveTypeToEdit.SaturdayHalf = false;
                          leaveTypeToEdit.SaturdayFull = true;
                        }
                      "
                    />
                    <span class="ml-2">Full Day</span>
                  </label>

                  <!-- <Switches text-disabled="Half Day" text-enabled="Full Day"></Switches> -->
                </div>
              </div>
            </div>

            <div class="">
              <!-- {{ leaveTypeToEdit }} -->
              <label class="block text-sm mb-2" for="emergency-switch">
                Handover Notes
              </label>
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="consecutive-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  v-model="leaveTypeToEdit.HandoverNotesRequired"
                />
                <label for="consecutive-switch" class="ml-2 block text-sm">
                  Requires Handover Notes
                </label>
              </div>
            </div>

            <div class="text-sm">
              <label class="block pb-1" for="policy-days"> Policy Days</label>
              <input
                id="policy-days"
                v-model="leaveTypeToEdit.PolicyDays"
                min="0"
                step="1"
                required
                type="number"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="">
              <label class="block text-sm mb-2" for="emergency-switch">
                Open January
              </label>
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="consecutive-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  v-model="leaveTypeToEdit.OpenJanuary"
                />
                <label for="consecutive-switch" class="ml-2 block text-sm">
                  Leave Opens in January
                </label>
              </div>
            </div>

            <div class="">
              <label class="block text-sm mb-2" for="emergency-switch">
                Close December
              </label>
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="consecutive-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  v-model="leaveTypeToEdit.CloseDecember"
                />
                <label for="consecutive-switch" class="ml-2 block text-sm">
                  Leave Closes in December
                </label>
              </div>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
// import Switches from 'vue-switches';

export default {
  name: "CompanySetupCreateLeaveTypes",
  props: ["showEditLeaveType", "leaveTypeToEdit"],
  components: { Loader },
  data() {
    return {
      edit_error: null,
      edit_success: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    created() {
      this.loading = true;
    },
    edit() {
      this.loading = false;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      this.leaveTypeToEdit.EarnedPerMonth = parseFloat(
        this.leaveTypeToEdit.EarnedPerMonth
      );

      if (this.leaveTypeToEdit.Consecutive) {
        this.leaveTypeToEdit.SaturdayFull = false;
        this.leaveTypeToEdit.SaturdayHalf = false;
      }
      axios
        .put(
          `${this.getOrganization}/setup/leavetype/${this.$ApiVersion}/edit`,
          JSON.stringify(this.leaveTypeToEdit),
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;
              this.edit_success = response.data.StatusMessage;

              setTimeout(() => {
                this.edit_success = null;
                this.$emit("closeOnSuccess");
              }, 2000);
            } else {
              this.edit_error = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_error = null;
              }, 2000);
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
            setTimeout(() => {
              this.edit_error = null;
            }, 2000);
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.slider.thumb-yellow {
  background-color: yellow;
}

.slider.thumb-yellow {
  background-color: yellow;
}

.slider.thumb-yellow {
  background-color: yellow;
}
</style>
